import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight } from "lucide-react";
import { ActivityCard } from "@/components/activity/ActivityCard";
import { SectionTitle } from "./SectionTitle";

export const ActivitiesSection = ({ activities = [] }) => {
  const today = new Date().toISOString().slice(0, 10);
  const upcoming = activities.filter((a) => a.date >= today).slice(0, 6);

  return (
    <section id="kegiatan" className="scroll-mt-24" data-testid="activities-section">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <SectionTitle eyebrow="Agenda Masjid" title="Kegiatan Mendatang" desc="Jadwal pengajian rutin, shalat Jumat & Ied, qurban, Ramadhan, PHBI, dan kegiatan sosial warga Banjarwaru. Klik kartu untuk detail dan bagikan ke keluarga." />
        <Link to="/kegiatan" className="inline-flex items-center gap-2 rounded-full border border-emerald-900/15 px-5 py-2.5 text-sm font-semibold text-emerald-900 hover:bg-emerald-50 transition-colors" data-testid="activities-see-all">
          Semua kegiatan <ArrowRight size={15} />
        </Link>
      </div>
      <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {upcoming.map((a) => <ActivityCard key={a.id} a={a} />)}
        {upcoming.length === 0 && (
          <div className="col-span-full rounded-3xl border border-dashed border-emerald-900/20 p-10 text-center text-slate-500" data-testid="activities-empty">
            <CalendarDays className="mx-auto mb-3 text-emerald-700" />
            Belum ada agenda kegiatan mendatang.
          </div>
        )}
      </div>
    </section>
  );
};
